var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-width":"1250px","margin":"auto"}},[_c('div',{staticClass:"p-grid"},_vm._l((_vm.Users),function(user){return _c("users-item",{key:user.id,tag:"div",staticClass:"p-col",attrs:{"userItem":user}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }